import React from 'react';
import {
  Typography,
  Box,
  Card,
  Stepper,
  Step,
  StepLabel,
  useTheme,
  useMediaQuery,
} from '@mui/material';

/**
 * How It Works widget for dashboard
 * Displays the complete survey lifecycle steps
 */
export const HowItWorksWidget: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const surveySteps = [
    'Template Selection',
    'Survey Creation',
    'Share QR Link',
    'Response collection',
    'Audit',
    'Report',
  ];

  return (
    <Box sx={{ mb: 5 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        How It Works
      </Typography>
      <Card
        elevation={0}
        sx={(theme) => ({
          p: 3,
          backgroundColor:
            theme.palette.mode === 'light' ? '#ffffff' : theme.palette.background.paper,
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.012), 0px 2px 8px rgba(0, 0, 0, 0.012)',
        })}
      >
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          Complete Survey Lifecycle
        </Typography>
        <Stepper
          activeStep={-1}
          orientation={isMobile ? 'vertical' : 'horizontal'}
          alternativeLabel={!isMobile}
          sx={{
            '& .MuiStepLabel-label': {
              fontSize: '0.875rem',
              fontWeight: 500,
            },
          }}
        >
          {surveySteps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Card>
    </Box>
  );
};
